export default __webpack_public_path__ + "08bda779e7be5c19f655d0f9ff689084.env";